import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Icon from '../../components/dashboard/DashboardIcons';
import { ChildCard } from './ParentHomePage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function ParentChildrenPage() {
  const navigate = useNavigate();
  const [children, setChildren] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/parent/me/children`, auth());
      setChildren(res.data || []);
    } catch {
      setChildren([]);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="parent-children-page">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-black text-[#0A192F]">أبنائي</h1>
        <button
          onClick={() => navigate('/parent/explore')}
          data-testid="parent-add-child-btn"
          className="flex items-center gap-1.5 rounded-lg bg-teal-600 px-4 py-2 text-sm font-bold text-white hover:bg-teal-700"
        >
          <Icon name="plus" className="h-4 w-4" /> إضافة ابن جديد
        </button>
      </div>

      {children === null ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {[1, 2].map((i) => <div key={i} className="h-32 animate-pulse rounded-2xl bg-slate-100" />)}
        </div>
      ) : children.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center" data-testid="parent-children-empty">
          <Icon name="users" className="mx-auto h-10 w-10 text-slate-300" />
          <p className="mt-3 text-sm font-semibold text-slate-600">لا يوجد أبناء مرتبطين بحسابك بعد</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-testid="parent-children-full-grid">
          {children.map((c) => <ChildCard key={c.player_id} child={c} />)}
        </div>
      )}
    </div>
  );
}
